<div class="kanban-card" [ngClass]="lead.status" (click)="openDetails()">
  <div class="kanban-card__contact-name">
    <mat-icon>person</mat-icon>
    <span>{{ lead.name }}</span>
  </div>

  <span class="kanban-card__last-observation">
    {{ lead.lastObservation ?? 'Sem informações' }}
  </span>

  <span class="kanban-card__created-at">
    <mat-icon>schedule</mat-icon>
    <span>{{ lead.createdAt | timeAgo }}</span>
  </span>
</div>
